import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTelegramSimpleIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.1847 2.95334C13.3495 2.884 13.5298 2.86009 13.7069 2.88409C13.884 2.90808 14.0515 2.97912 14.1918 3.0898C14.3322 3.20048 14.4403 3.34675 14.505 3.5134C14.5696 3.68004 14.5884 3.86097 14.5594 4.03734L13.0474 13.2087C12.9007 14.0933 11.9301 14.6007 11.1187 14.16C10.4401 13.7913 9.43205 13.2233 8.52539 12.6307C8.07205 12.334 6.68339 11.384 6.85405 10.708C7.00072 10.13 9.33405 7.95801 10.6674 6.66667C11.1907 6.15934 10.9521 5.86667 10.3341 6.33334C8.79939 7.49201 6.33539 9.25401 5.52072 9.75001C4.80205 10.1873 4.42739 10.262 3.97939 10.1873C3.16205 10.0513 2.40405 9.84067 1.78539 9.58401C0.949387 9.23734 0.990054 8.08801 1.78472 7.75334L13.1847 2.95334Z",
		fill: "#A3A3A3"
	})
});
export default SvgTelegramSimpleIcon;
